import React, { useState } from "react"
import { useSurveyConfigurationContext } from "contexts/SurveyConfigurationContext"
import { SURVEY_CONFIGURATION_SETTINGS_TAB_SLUG } from "utils/tabSlugHelpers"
import SurveyConfigurationEdit from "./SurveyConfigurationEdit"
import SettingsTitle from "./SettingsTitle"
import SurveyConfigurationOverview from "./SurveyConfigurationOverview"

export const SETTINGS_HEADING = "Settings"

const SurveyConfigurationSettingsTab = () => {
  const { surveyConfiguration } = useSurveyConfigurationContext()
  const [editMode, setEditMode] = useState(false)
  const openEditMode = () => setEditMode(true)
  const closeEditMode = () => setEditMode(false)

  return (
    <>
      <SettingsTitle
        editMode={editMode}
        openEditMode={openEditMode}
        heading={SETTINGS_HEADING}
      />

      <div>
        {
          editMode
            ? (
              <SurveyConfigurationEdit
                surveyConfiguration={surveyConfiguration}
                activeTab={SURVEY_CONFIGURATION_SETTINGS_TAB_SLUG}
                closeEditMode={closeEditMode}
              />
            )
            : <SurveyConfigurationOverview />
        }
      </div>
    </>
  )
}

export default SurveyConfigurationSettingsTab
